import { Component, OnInit, Pipe } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "primeng/api";

import { environment } from "../../environments/environment";
import { SessionService } from "../common/services/session.service";
import { IF_LoginRes } from "../interfaces/login.interface";
import { IF_LoginReq } from "./../interfaces/login.interface";
import { LoginApiService } from "./services/login.api.service";
import { LoginService } from "./services/login.service";

declare var $: any;
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  providers: [MessageService, Pipe],
})
export class LoginComponent implements OnInit {
  loginObj: IF_LoginReq;
  errorFlag: boolean = false;
  userState: boolean = false;
  passState: boolean = false;
  message: string = "";
  instanceConfig: any;
  eyeon: boolean = false;
  sysLang: any;
  fileViewAPI = "";

  constructor(
    private router: Router,
    private arouter: ActivatedRoute,
    //private toast: MessageService,
    private apiService: LoginApiService,
    private readonly service: LoginService,
    private ss: SessionService,
    //private elRef: ElementRef,
    private titleService: Title,
    private translate: TranslateService
  ) {
    this.loginObj = {
      username: "",
      password: "",
    };
    //this.ss.flushSession();
    this.instanceConfig = this.arouter.snapshot.data.instanceConfig;
    this.processInstanceConfig();
  }

  onclick_event() {
    this.errorFlag = false;
  }

  login(logindata) {
    if (!logindata.valid) {
    } else {
      this.apiService.doLogin(this.loginObj).subscribe(
        (loginData: IF_LoginRes) => {
          this.sysLang = loginData.role;
          if (loginData.role == "SYSTEM_ADMIN") {
            this.ss.setAuthPermission(null);
            this.service.onAuthSuccess(loginData);
            this.getActiveLang();
          } else {
            let id = loginData.accessControl.id;
            this.service.onAuthSuccess(loginData);
            this.apiService.getPermission(id).subscribe((res) => {
              let data = res;
              this.ss.setAuthPermission(JSON.stringify(data.modules));
              this.getActiveLang();
            });
          }
        },
        (e) => {
          if (e != undefined) {
            this.errorFlag = true;
          }
          this.message = e.error.message;
        }
      );
    }
  }

  ngOnInit() {
    //this.ss.flushSession();
    setTimeout(() => {
      $(".text-box input").on("focus", function () {
        $(this).addClass("focus");
      });

      $(".text-box input").on("blur", function () {
        if ($(this).val() === "") {
          $(this).removeClass("focus");
        }
      });
    });
  }

  private processInstanceConfig() {
    if (this.instanceConfig) {
      environment.API_BASE = this.instanceConfig.BASE_API;
      this.apiService.getSystemConfig().subscribe((res: any) => {
        this.instanceConfig = { ...this.instanceConfig, ...res };
        // this.instanceConfig = this.ss.preSetInstanceConfigs(
        //   this.instanceConfig
        // );
        this.titleService.setTitle(this.instanceConfig.BRANDING_PAGE_TITLE);
        this.fileViewAPI = `${environment.API_BASE}${environment.FILE_VIEW_S3}`;
        this.ss.setInstanceConfig(this.instanceConfig);
      });

      // this.instanceConfig = this.ss.preSetInstanceConfigs(this.instanceConfig);
      // this.titleService.setTitle(this.instanceConfig.BRANDING_PAGE_TITLE);
      // this.ss.setInstanceConfig(this.instanceConfig);
      // environment.API_BASE = this.instanceConfig.BASE_API;
    } else {
      this.instanceConfig = this.arouter.snapshot.data.instanceConfig;

      this.processInstanceConfig();
    }
  }
  private getActiveLang() {
    this.apiService.getActiveLang().subscribe(
      (res: any) => {
        if (this.sysLang !== "SYSTEM_ADMIN") {
          localStorage.setItem("selectedLang", res.key);
          this.translate.use(res.key);
          this.router.navigate(["/main-dashboard"]);
        } else {
          localStorage.setItem("selectedLang", (res.key = "en"));
          this.translate.use((res.key = "en"));
          this.router.navigate(["/main-dashboard"]);
        }
      },
      (err: any) => {
        localStorage  .setItem("selectedLang", "en");
        this.translate.use("en");
        this.router.navigate(["/main-dashboard"]);
      }
    );
  }
  toggleeye() {
    this.eyeon = !this.eyeon;
  }
}
